// log app operations and message ops.

import {
  EnuAppOps,
  LogRecord,
  TApplicationLog,
  TBlueTable,
} from "@app/types/insider";

export const applog: TBlueTable<TApplicationLog> = {
  name: "applog",
  initialState: {} as LogRecord,
  empty: {} as TApplicationLog,
  apiUrl: null,
  pkeyUrl: null,
  primaryKey: null,
  starfx: true,
  idb: false,
  bootPriority: -1,
  onmru: "no",
  oncsdb: "no",
  label: "Application Log",
  appContext: [],
};
